import React from "react";
import { DataTable } from "@sscs/ui";
import styles from "./behaviour.module.scss";
import BehaviourDetails from "./behaviourDetails/BehaviourDetails";
const COLUMNS = [
    { id: "info", label: "Info", width: "70px" },
    { id: "category", label: "Category", width: "120px" },
    {
        id: "id",
        label: "ID",
        sortProperty: "identifier",
        sortId: "behavior-sort-id",
        width: "100px",
    },
    { id: "description", label: "Description", width: "100%" },
    {
        id: "count",
        label: "Count",
        sortProperty: "component_count",
        sortId: "behavior-sort-count",
        startReverse: true,
        width: "110px",
    },
];
const BehaviourTable = ({ indicators, sort, searchRegex, filters, onSortChange, status, itemCount, pagination, onPaginationChange, }) => {
    return (React.createElement(DataTable, { tableClassName: styles.table, columns: COLUMNS, sort: sort, onSortChange: onSortChange, status: status, empty: { subject: "behaviors", filters }, pagination: {
            id: "behavior-pagination",
            itemCount,
            pagination,
            onChange: onPaginationChange,
        } }, indicators.map((behaviour, index) => (React.createElement(BehaviourDetails, { key: behaviour.identifier, behaviour: behaviour, searchRegex: searchRegex, index: index })))));
};
export default BehaviourTable;
//# sourceMappingURL=BehaviourTable.js.map